/**
 * Build-time configuration injected by Vite's `define`.
 *
 * - Development: backend URL defaults to localhost; SW disabled; verbose logs.
 * - Production: backend URL baked in at build time from VITE_PROD_BACKEND_URL.
 *
 * The shared secret is NOT baked in — it would leak in a JS bundle. Production
 * field auth uses the same Cognito email-code flow as the dashboard.
 */

declare const __PROD_BACKEND_URL__: string;
declare const __BUILD_MODE__: string;
declare const __APP_VERSION__: string;
declare const __BUILD_ID__: string;

const PROD_BACKEND_URL = __PROD_BACKEND_URL__;
const BUILD_MODE = __BUILD_MODE__;

/** Baked in by the Vite build. Compared with /version.json while the tab stays open. */
export const buildId = typeof __BUILD_ID__ === 'string' ? __BUILD_ID__ : 'dev';
export const appVersion = typeof __APP_VERSION__ === 'string' ? __APP_VERSION__ : '0.1.1';

export const isProduction = BUILD_MODE === 'production';

export const backendBaseUrl = isProduction
  ? PROD_BACKEND_URL || window.location.origin
  : 'http://localhost:3000';

export function log(...args: unknown[]): void {
  if (!isProduction) {
    console.log('[field]', ...args);
  }
}
